import { ref } from 'vue'
import it from '../locales/it.json'
import en from '../locales/en.json'

const savedLanguage = localStorage.getItem('user-language')
const currentLanguage = ref(savedLanguage || 'it')
const messages = { it, en }

export function useLanguage() {
  const setLanguage = (lang) => {
    currentLanguage.value = lang
    localStorage.setItem('user-language', lang)
  }

  const isItalian = () => currentLanguage.value === 'it'
  const isEnglish = () => currentLanguage.value === 'en'

  const t = (key, params = {}) => {
    const keys = key.split('.')
    let value = messages[currentLanguage.value]
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k]
      } else {
        return key
      }
    }

    if (typeof value === 'string' && params) {
      Object.keys(params).forEach(p => {
        value = value.replace(`{${p}}`, params[p])
      })
    }

    return value
  }

  return {
    currentLanguage,
    setLanguage,
    isItalian,
    isEnglish,
    t
  }
}
